import { z } from "zod";

import { activityFormatSchema } from "./library.js";
import { activitySessionSchema, scheduleDateSchema } from "./scheduling.js";

export const todaySessionSchema = activitySessionSchema.extend({
  activityTitle: z.string().nullable(),
  collectionName: z.string().nullable(),
  activityAvailable: z.boolean(),
  activityDurationMinutes: z.number().int().positive().nullable(),
  completionId: z.uuid().nullable(),
  completedSessionCount: z.number().int().nonnegative(),
  hasFlashcards: z.boolean(),
});

export const todayWeekDaySchema = z.object({
  date: scheduleDateSchema,
  sessionCount: z.number().int().nonnegative(),
  completedSessionCount: z.number().int().nonnegative(),
  isToday: z.boolean(),
});

export const todayWeekSchema = z.object({
  startDate: scheduleDateSchema,
  endDate: scheduleDateSchema,
  days: z.array(todayWeekDaySchema).length(7),
  totalSessions: z.number().int().nonnegative(),
  completedSessions: z.number().int().nonnegative(),
  plannedMinutes: z.number().int().nonnegative(),
});

export const todayUpcomingDaySchema = z.object({
  date: scheduleDateSchema,
  sessions: z.array(todaySessionSchema),
});

export const todayFavouriteCandidateSchema = z.object({
  activityId: z.uuid(),
  title: z.string().min(1),
  collectionName: z.string().nullable(),
  estimatedMinutes: z.number().int().positive(),
  interest: z.number().int().min(1).max(5).nullable(),
  format: activityFormatSchema,
  hasFlashcards: z.boolean(),
});

export const todayResponseSchema = z.object({
  date: scheduleDateSchema,
  displayName: z.string().min(1),
  greeting: z.enum(["Good morning", "Good afternoon", "Good evening"]),
  timeZone: z.string().min(1),
  usedFallbackTimeZone: z.boolean(),
  sessions: z.array(todaySessionSchema),
  week: todayWeekSchema,
  comingUp: z.array(todayUpcomingDaySchema).length(4),
  favouriteCandidates: z.array(todayFavouriteCandidateSchema),
});

export const activityOpenedResponseSchema = z.object({
  activityId: z.uuid(),
  openedAt: z.string(),
});

export type TodaySession = z.infer<typeof todaySessionSchema>;
export type TodayWeek = z.infer<typeof todayWeekSchema>;
export type TodayUpcomingDay = z.infer<typeof todayUpcomingDaySchema>;
export type TodayFavouriteCandidate = z.infer<typeof todayFavouriteCandidateSchema>;
export type TodayResponse = z.infer<typeof todayResponseSchema>;
export type ActivityOpenedResponse = z.infer<typeof activityOpenedResponseSchema>;
